import * as React from "react";
import { trackBeginCheckout } from "src/js/analytics/analytics-events";
import Loader from "src/js/components/Loader/LoadingSpinner";

interface buttonProps {
  canCheckout: boolean;
  marketplaceAllowed: boolean;
  marketplaceOnly: boolean;
}

export const CheckoutButtons: React.FunctionComponent<buttonProps> = (
  props: buttonProps,
) => {
  const [marketplace] = React.useState(props.marketplaceOnly);

  const [submitting, setSubmitting] = React.useState(false);

  let checkoutAction = (e) => {
    setSubmitting(true);

    e.preventDefault();
    //send begin_checkout event to Google Analytics
    trackBeginCheckout();
    let url = "/Cart/Checkout";
    if (marketplace) {
      url += "?options=marketplace";
    }

    location.href = url;
  };

  let checkoutText = <>Checkout</>;
  let buttonClass = "standard-button checkout ",
    ariaLabel = "Checkout";

  if (!props.canCheckout) {
    // cannot checkout.  disable button.
    buttonClass += " disabled";
    ariaLabel = "Resolve Cart Issues to Proceed";

    checkoutAction = (e) => {
      e.preventDefault();
      // do nothing, we are disabled
    };
  }

  if (submitting) {
    buttonClass += " submitting";
    ariaLabel = "Starting Checkout";
    checkoutText = <Loader message="Starting Checkout..."></Loader>;
  }

  return (
    <>
      <div className="cart-buttons">
        <button
          type="button"
          className={buttonClass}
          aria-label={ariaLabel}
          data-tooltip="Resolve Cart Issues to Proceed"
          onClick={checkoutAction}
        >
          {checkoutText}
        </button>
      </div>
    </>
  );
};
